/* Ink-wash styling for rendered Markdown (the Analysis page). Element
   selectors are scoped under the hashed `.prose` class by CSS Modules. */

.prose {
  color: var(--paper-dim);
  line-height: 1.72;
  font-size: 1.02rem;
}

.prose > * + * {
  margin-top: 1.15em;
}

.prose h1 {
  font-family: var(--serif);
  font-size: clamp(2rem, 5vw, 2.9rem);
  font-weight: 500;
  line-height: 1.12;
  color: var(--paper);
  letter-spacing: 0.01em;
}

.prose h2 {
  font-family: var(--serif);
  font-size: clamp(1.4rem, 3.2vw, 1.8rem);
  font-weight: 500;
  color: var(--paper);
  margin-top: 2.4em;
  padding-top: 1.4em;
  border-top: 1px solid var(--paper-ghost);
}

.prose h3 {
  font-family: var(--serif);
  font-size: 1.25rem;
  color: var(--paper);
  margin-top: 1.8em;
}

.prose h1 + *,
.prose h2 + *,
.prose h3 + * {
  margin-top: 0.9em;
}

.prose strong {
  color: var(--paper);
  font-weight: 600;
}

.prose em {
  font-style: italic;
  color: var(--paper);
}

.prose a {
  color: var(--gold);
  border-bottom: 1px solid var(--gold-soft);
  transition: color 0.35s var(--ease-soft), border-color 0.35s var(--ease-soft);
}
.prose a:hover {
  color: var(--paper);
  border-color: var(--gold);
}

.prose code {
  font-family: var(--mono);
  font-size: 0.82em;
  color: var(--gold);
  background: rgba(184, 150, 104, 0.08);
  border: 1px solid var(--paper-ghost);
  border-radius: 5px;
  padding: 0.08em 0.4em;
  word-break: break-word;
}

.prose pre {
  font-family: var(--mono);
  font-size: 0.8rem;
  line-height: 1.6;
  color: var(--paper-dim);
  background: var(--ink-2);
  border: 1px solid var(--paper-ghost);
  border-radius: 12px;
  padding: 1.1rem 1.2rem;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}
.prose pre code {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font-size: inherit;
}

.prose blockquote {
  font-family: var(--serif);
  font-style: italic;
  font-size: 1.12rem;
  color: var(--paper);
  border-left: 2px solid var(--cinnabar-soft);
  padding: 0.1rem 0 0.1rem 1.3rem;
  margin-left: 0;
}

.prose ul {
  margin-top: 1.1em;
  padding-left: 1.2rem;
  list-style: none;
}
.prose li {
  position: relative;
  padding-left: 0.4rem;
}
.prose li + li {
  margin-top: 0.7em;
}
.prose li::before {
  content: '';
  position: absolute;
  left: -0.7rem;
  top: 0.62em;
  width: 5px;
  height: 5px;
  transform: rotate(45deg);
  background: var(--gold-soft);
}

/* tables — let them scroll horizontally on narrow viewports */
.prose table {
  display: block;
  width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
  font-family: var(--sans);
  font-size: 0.82rem;
  line-height: 1.5;
}
.prose thead th {
  text-align: left;
  font-weight: 600;
  color: var(--gold);
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--gold-soft);
  padding: 0.55rem 0.9rem 0.55rem 0;
  white-space: nowrap;
}
.prose tbody td {
  color: var(--paper-dim);
  border-bottom: 1px solid var(--paper-ghost);
  padding: 0.7rem 0.9rem 0.7rem 0;
  vertical-align: top;
}
.prose tbody tr:last-child td {
  border-bottom: none;
}
.prose td code {
  font-size: 0.78em;
}
